export default __webpack_public_path__ + "static/media/9022_banner_mobile.cf2b860b.png";